import { FunctionComponentChildren } from '@/@types/react'
import * as Sentry from '@sentry/react'
import { FeedbackError } from './components/FeedbackError'

export const ErrorBoundary: FunctionComponentChildren = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={error => <FeedbackError eventId={error.eventId} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
